import Quill from 'quill'

const BlockEmbed = Quill.import('blots/block/embed')

const DESCRIPTION_PLACEHOLDER = 'Lorem ipsum dolor sit amet...'
const BUTTON_PLACEHOLDER = 'Button'

export default class BaseAdsBannerBlot extends BlockEmbed {
  static create() {
    const type = this.getBannerType()

    if (this.checkDuplicateBanner(type)) {
      alert(`Only one ${type} banner is allowed.`)
      return null
    }

    const node = super.create()
    node.setAttribute('data-banner-type', type)

    if (type === 'vertical') node.classList.add('ads-banner-vertical')

    const bannerEl = document.getElementById('admin-article-app')
    node.setAttribute('data-entity-id', bannerEl.getAttribute('data-entity_id'))
    node.setAttribute(
      'data-entity-type',
      bannerEl.getAttribute('data-entity_type')
    )

    const infoBlock = document.createElement('div')
    infoBlock.classList.add('info-block')

    const descriptionElement = document.createElement('span')
    descriptionElement.innerText = DESCRIPTION_PLACEHOLDER
    infoBlock.appendChild(descriptionElement)

    const buttonElement = document.createElement('div')
    buttonElement.classList.add('button')
    buttonElement.innerText = BUTTON_PLACEHOLDER
    infoBlock.appendChild(buttonElement)

    const imageElement = document.createElement('img')
    imageElement.src = window.NO_IMAGE_FALLBACK
    imageElement.alt = 'Banner Image'

    node.appendChild(infoBlock)
    node.appendChild(imageElement)

    return node
  }

  static getBannerType() {
    throw new Error('getBannerType() must be implemented by subclass')
  }

  static checkDuplicateBanner(type) {
    const editorRoot = document.querySelector('.ql-editor')
    if (!editorRoot) return false

    const existing = editorRoot.querySelectorAll(`[data-banner-type="${type}"]`)
    return existing.length >= 1
  }

  static initBanners(bannerNode, data) {
    const descriptionBlock = bannerNode.querySelector('.info-block span')
    const buttonBlock = bannerNode.querySelector('.button')
    const imageBlock = bannerNode.querySelector('img')

    if (descriptionBlock) descriptionBlock.innerText = data.description
    if (buttonBlock) {
      buttonBlock.innerText = data.button_name
      buttonBlock.onclick = () => window.open(data.button_link, '_self')
    }
    if (imageBlock) imageBlock.src = data.thumbnail_url
  }
}
